import { render, staticRenderFns } from "./VirtualMobile.vue?vue&type=template&id=5054db17"
import script from "./VirtualMobile.vue?vue&type=script&lang=js"
export * from "./VirtualMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports